/**
 * Shared reveal mechanism for the `.branding-reveal` cross-dissolve
 * (globals.scss). Both `useBrandingReveal` (full branding lands) and
 * `useTeamGradientReveal` (mid-session favorite-team color change) pulse this
 * same class, so the class name and window live here once — changing the
 * duration or class must not require touching two hooks.
 *
 * Full and team reveals are mutually exclusive in practice (a full-branding
 * session suppresses team personalization), so the single shared class having
 * two callers does not race in the flows that actually occur.
 */
export const REVEAL_CLASS = 'branding-reveal'
export const REVEAL_WINDOW_MS = 700

/**
 * Tags <html> with the reveal class for one REVEAL_WINDOW_MS window. Returns a
 * cleanup that clears the timer and removes the class — call it from a layout
 * effect and return the result so React tears it down on unmount / re-run.
 */
export function pulseRevealClass(): () => void {
  const root = document.documentElement
  root.classList.add(REVEAL_CLASS)
  const timer = setTimeout(() => root.classList.remove(REVEAL_CLASS), REVEAL_WINDOW_MS)
  return () => {
    clearTimeout(timer)
    root.classList.remove(REVEAL_CLASS)
  }
}
